import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { CoreContext } from './context/index.js';
import Link from './components/Link/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import useAutoFocus from './hooks/useAutoFocus.js';
import './index-mh98rJ1p.js';
import 'notistack';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { a as ACCOUNT_MENU_ITEMS } from './account-o8FpsAAZ.js';

const MyAccount = ({ onLogout }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { actions: { modal: { toggleModal, toggleShowMobileMenu }, }, useDispatch, } = useContext(CoreContext);
    const { locale, push } = useRouter();
    const dispatch = useDispatch();
    const router = useRouter();
    const handleClose = () => {
        dispatch(toggleModal(null));
    };
    const logoutHandler = () => {
        handleClose();
        onLogout();
    };
    const goToPage = (url) => {
        push(`/${locale}${url}`);
        dispatch(toggleShowMobileMenu(false));
        handleClose();
    };
    const ref = useAutoFocus({ tag: 'button' });
    return (React.createElement("ul", { ref: ref, className: "account-list" },
        ACCOUNT_MENU_ITEMS.map(item => (React.createElement("li", { key: item.name },
            React.createElement(Link, { className: classnames('drawer-option uppercase', {
                    active: router.pathname === item.path,
                }), onClick: () => goToPage(item.path), noUnderline: true }, tLabel(item.name))))),
        React.createElement("li", null,
            React.createElement(Link, { className: "drawer-option uppercase", onClick: logoutHandler, black: true, noUnderline: true }, tButton('logOut')))));
};

export { MyAccount as M };
//# sourceMappingURL=MyAccount-ZYNX2sdh.js.map
